(() => {
  if (window.landingB2BExpertTestimonials) {
    window.landingB2BExpertTestimonials.initAll();
    return;
  }

  const sectionSelector = '[data-landing-b2b-expert-testimonials]';
  const sliderSelector = '[data-testimonials-slider]';
  const prevSelector = '[data-testimonials-prev]';
  const nextSelector = '[data-testimonials-next]';
  const activeClass = 'is-slider-active';

  const instances = new WeakMap();

  const getCssLengthInPixels = (element, propertyName, fallback) => {
    const value = window.getComputedStyle(element).getPropertyValue(propertyName).trim();

    if (!value) {
      return fallback;
    }

    if (value.endsWith('rem')) {
      const rootFontSize =
        parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 10;
      return parseFloat(value) * rootFontSize;
    }

    if (value.endsWith('px')) {
      return parseFloat(value);
    }

    const numericValue = parseFloat(value);

    return Number.isNaN(numericValue) ? fallback : numericValue;
  };

  const getTrackGap = (track) => {
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap);

    return Number.isNaN(gap) ? 32 : gap;
  };

  const getSlides = (section) => {
    return Array.from(section.querySelectorAll('.landing-b2b-expert-testimonials__card'));
  };

  const shouldUseSlider = (section) => {
    const slider = section.querySelector(sliderSelector);
    const track = section.querySelector('.landing-b2b-expert-testimonials__track');
    const slides = getSlides(section);

    if (!slider || !track || slides.length <= 1) {
      return false;
    }

    if (slides.length > 3) {
      return true;
    }

    const sliderWidth = slider.clientWidth;
    const minCardWidth = getCssLengthInPixels(
      section,
      '--landing-b2b-expert-testimonials-card-min-width',
      360,
    );
    const gap = getTrackGap(track);
    const requiredWidth = slides.length * minCardWidth + (slides.length - 1) * gap;

    return requiredWidth > sliderWidth;
  };

  const enableSlider = (section) => {
    const slider = section.querySelector(sliderSelector);
    const prevButton = section.querySelector(prevSelector);
    const nextButton = section.querySelector(nextSelector);
    const slides = getSlides(section);

    if (!slider || !prevButton || !nextButton || instances.has(section)) {
      return;
    }

    if (!window.Swiper) {
      return;
    }

    section.classList.add(activeClass);
    slider.classList.add(activeClass);

    const swiper = new window.Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 500,
      loop: false,
      watchOverflow: true,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      breakpoints: {
        750: {
          slidesPerView: Math.min(2, slides.length),
          spaceBetween: 24,
        },
        990: {
          slidesPerView: Math.min(3, slides.length),
          spaceBetween: 32,
        },
      },
    });

    instances.set(section, swiper);
  };

  const disableSlider = (section) => {
    const slider = section.querySelector(sliderSelector);
    const swiper = instances.get(section);

    if (swiper && !swiper.destroyed) {
      swiper.destroy(true, true);
    }

    instances.delete(section);
    section.classList.remove(activeClass);

    if (slider) {
      slider.classList.remove(activeClass);
    }
  };

  const updateSection = (section) => {
    const swiper = instances.get(section);
    const needsSlider = shouldUseSlider(section);

    if (needsSlider) {
      if (swiper && !swiper.destroyed) {
        swiper.update();
      } else {
        enableSlider(section);
      }

      return;
    }

    disableSlider(section);
  };

  const initSection = (section) => {
    if (!section) {
      return;
    }

    window.requestAnimationFrame(() => {
      updateSection(section);
    });
  };

  const initAll = () => {
    document.querySelectorAll(sectionSelector).forEach(initSection);
  };

  let resizeTimer = null;

  const handleResize = () => {
    window.clearTimeout(resizeTimer);

    resizeTimer = window.setTimeout(() => {
      document.querySelectorAll(sectionSelector).forEach(updateSection);
    }, 150);
  };

  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('resize', handleResize);

  document.addEventListener('shopify:section:load', (event) => {
    initSection(event.target.querySelector(sectionSelector) || event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector(sectionSelector) || event.target;
    disableSlider(section);
  });

  window.landingB2BExpertTestimonials = {
    initAll,
  };

  initAll();
})();
